import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Grid,
  Pagination,
  useMediaQuery,
  useTheme,
  Button,
  CircularProgress,
} from "@mui/material";
import { colors, fonts } from "../ColorFont/color";
import { url } from "../ConstUrl/Url";
import { useTranslation } from "react-i18next";
import UnifiedCropCard from "../components/UnifiedCropCard";
import { IconSearch } from "@tabler/icons-react";

const ViewedPlots = ({ userData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const userId = userData?._id;
  const [viewedCrops, setViewedCrops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pageData, setPageData] = useState(null);

  const handleChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    const fetchViewedPlots = async () => {
      if (!userId) return;
      try {
        setLoading(true);
        const response = await fetch(`${url}/api/purchasedPlots/${userId}?page=${page}`);
        const data = await response.json();
        setViewedCrops(data.paginatedPlots || []);
        setPageData(data);
      } catch (error) {
        console.error("Error fetching purchasedPlots:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchViewedPlots();
  }, [userId, page]);

  if (loading && page === 1) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <CircularProgress sx={{ color: colors.primary }} />
      </Box>
    );
  }

  return (
    <Box sx={{ background: colors.background3, minHeight: '100vh' }}>
      <Box sx={{ px: { xs: 2, md: 5 }, py: { xs: 4, md: 6 }, pb: 8 }}>
        {/* Header Section */}
        <Box sx={{ mb: 5, textAlign: 'center' }}>
          <Typography
            sx={{
              fontFamily: fonts.poppins,
              fontSize: { xs: '28px', md: '40px' },
              fontWeight: 800,
              color: '#1C252E',
              mb: 1,
              letterSpacing: '-1px'
            }}
          >
            {t('dashboard:viewedPlots')}
          </Typography>
          <Typography sx={{ color: '#637381', fontFamily: fonts.poppins, fontSize: '16px' }}>
            {t('dashboard:viewedCropsSubtitle')}
          </Typography>
        </Box>

        {viewedCrops.length === 0 ? (
          <Box sx={{ 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            py: 10,
            textAlign: 'center',
            bgcolor: '#FFFFFF',
            borderRadius: '24px',
            border: '1px dashed #E0E5EB'
          }}>
            <Box sx={{ 
              width: 80, height: 80, borderRadius: '24px', 
              bgcolor: '#F4F6F8', display: 'flex', 
              alignItems: 'center', justifyContent: 'center', mb: 3 
            }}>
              <IconSearch size={40} color="#919EAB" />
            </Box>
            <Typography sx={{ fontFamily: fonts.poppins, fontWeight: 700, fontSize: '20px', color: '#1C252E', mb: 1 }}>
              {t('dashboard:noCropsViewed')}
            </Typography>
            <Typography sx={{ color: '#637381', mb: 4, maxWidth: 300 }}>
              {t('dashboard:noCropsViewedDesc')}
            </Typography>
            <Button
              variant="contained"
              onClick={() => navigate('/explore')}
              sx={{
                bgcolor: colors.primary,
                px: 4, py: 1.5, borderRadius: '12px',
                textTransform: 'none', fontWeight: 700,
                '&:hover': { bgcolor: colors.primary_dark }
              }}
            >
              {t('dashboard:exploreListings')}
            </Button>
          </Box>
        ) : (
          <>
            <Grid container spacing={4} sx={{ mt: 2 }}>
              {viewedCrops.map((crop) => (
                <Grid item xs={12} sm={6} md={4} key={crop._id}>
                  <UnifiedCropCard 
                      crop={crop} 
                      userData={userData}
                      isExplore={true}
                      onGetContact={() => {}} // Already purchased
                  />
                </Grid>
              ))}
            </Grid>

            {pageData && pageData.pageCount > 1 && (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
                <Pagination
                  count={pageData.pageCount}
                  color="primary"
                  onChange={handleChange}
                  page={page}
                  sx={{
                      '& .MuiPaginationItem-root': {
                          fontWeight: 700,
                          borderRadius: '8px',
                          fontFamily: fonts.poppins
                      }
                  }}
                />
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default ViewedPlots;
